import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from "@redux/actionTypes";
import { useAuth } from "@context";
import { safeLocalStorage } from '@utils/localstorage';
import { useRouter } from 'next/router';
const isBrowser = typeof window !== "undefined";

const useSignOut = () => {
    const dispatch = useDispatch();
    const { web3AuthLogout } = useAuth();
    const userDetails = useSelector((state) => state.setUserDetails.user);
    const router = useRouter();

    const signOutHandler = async () => {
        try {
            if (isBrowser) {
                if (window?.Intercom) {
                    window.Intercom('shutdown');
                }
                if (window?.gtag) {
                    window.gtag("config", "G-XXFJFZBQM2", {
                        user_id: userDetails?.id
                    });
                    window.gtag("event", "sign_out", {
                        user_id: userDetails?.id
                    })
                }
                web3AuthLogout();
                safeLocalStorage.clear();
                safeLocalStorage.clearSessionStorage();
                safeLocalStorage.setItem('openlogin_store', {})
                dispatch({
                    type: actionTypes.CLEAR_REDUX,
                    payload: {},
                });
                router.push('/');
            }
        } catch (e) {
            console.log("error:", e);
        }
    };

    return { signOutHandler };
};

export default useSignOut;
